import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const activeCat = params.get("cat") || "all";

  useEffect(() => {
    api.get("/categories").then((r) => setCategories(r.data)).catch(() => setCategories([]));
  }, []);

  useEffect(() => {
    setLoading(true);
    const q = {};
    if (activeCat !== "all") q.category = activeCat;
    if (search) q.search = search;
    const t = setTimeout(() => {
      api.get("/products", { params: q })
        .then((r) => setProducts(r.data))
        .catch(() => setProducts([]))
        .finally(() => setLoading(false));
    }, 250);
    return () => clearTimeout(t);
  }, [activeCat, search]);

  const setCat = (c) => {
    if (c === "all") setParams({});
    else setParams({ cat: c });
  };

  return (
    <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-14">
      <div className="mb-10">
        <div className="overline text-[#B89C65] mb-3">Loja</div>
        <h1 className="font-serif text-5xl md:text-6xl text-[#1A1A1A]">
          {activeCat === "all" ? "Todos os produtos" : activeCat}
        </h1>
      </div>

      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 mb-12 border-b border-[#1A1A1A]/10 pb-6">
        <div className="flex flex-wrap gap-2">
          <button data-testid="filter-all" onClick={() => setCat("all")}
            className={`overline px-4 py-2 border transition-colors ${activeCat === "all" ? "bg-[#1A1A1A] text-[#F8F7F4] border-[#1A1A1A]" : "border-[#1A1A1A]/20 text-[#1A1A1A]/70 hover:border-[#1A1A1A]"}`}>
            Todos
          </button>
          {categories.map((c) => (
            <button key={c} data-testid={`filter-${c}`} onClick={() => setCat(c)}
              className={`overline px-4 py-2 border transition-colors ${activeCat === c ? "bg-[#1A1A1A] text-[#F8F7F4] border-[#1A1A1A]" : "border-[#1A1A1A]/20 text-[#1A1A1A]/70 hover:border-[#1A1A1A]"}`}>
              {c}
            </button>
          ))}
        </div>
        <input data-testid="search-input" value={search} onChange={(e) => setSearch(e.target.value)}
          placeholder="Buscar peças…"
          className="bg-transparent border-b border-[#1A1A1A]/20 focus:border-[#B89C65] outline-none py-2 px-1 text-[#1A1A1A] placeholder:text-[#1A1A1A]/40 md:w-64 transition-colors" />
      </div>

      {loading ? (
        <div className="py-24 text-center font-serif text-2xl text-[#1A1A1A]/50">Carregando…</div>
      ) : products.length === 0 ? (
        <div data-testid="no-products" className="py-24 text-center font-serif text-2xl text-[#1A1A1A]/50">Nenhum produto encontrado.</div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
